<app-header [forceLightBackground]="true"></app-header>
<div class="admin-contributions">
  <div class="admin-contributions--layout">
    <app-admin-sidebar class="admin-contributions--sidebar"></app-admin-sidebar>
    <div class="admin-contributions--content">
      <app-page-header></app-page-header>
      <div class="contributions-container">
        <app-manage-contribution 
          (reloadData)="loadAllAssets()"
          (filterChange)="onFilterChange($event)"
          (sortChange)="onSortChange($event)">
        </app-manage-contribution>
      </div>
    </div>
  </div>
</div>



